export var DATA_HOOKS;
(function (DATA_HOOKS) {
    DATA_HOOKS["FORM_ROOT"] = "form-root";
    DATA_HOOKS["FORM_VIEWER_NO_FORM_ERROR"] = "form-viewer-no-form-error";
})(DATA_HOOKS || (DATA_HOOKS = {}));
//# sourceMappingURL=data-hooks.js.map